class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keydown', (evt) => {
      if (evt.key !== 'Tab' || evt.target.closest('cart-disclosure-modal[open]')) return;
      const controls = getFocusableElements(this.notification).filter((el) => el.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (evt.shiftKey && (document.activeElement === first || document.activeElement === this.notification)) {
        evt.preventDefault();
        last?.focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first?.focus();
      }
    });
    this.notification.addEventListener('cancel', (evt) => {
      evt.preventDefault();
      const disclosure = this.notification.querySelector('cart-disclosure-modal[open]');
      if (disclosure) disclosure.hide();
      else this.close();
    });
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    if (this.notification.open) return;
    this.activeElement = this.activeElement || document.activeElement;
    this.notification.classList.add('active');
    this.notification.showModal();
    document.body.classList.add('cart-notification-open');
    trapFocus(this.notification, this.querySelector('.cart-notification__close'));
    this.notification.addEventListener('click', this.onBodyClick);

    this.dispatchCartViewEvent();
  }

  // The notification's outer element is server-rendered once at page load, so
  // its `cart` Liquid object reflects the pre-add state. The morphed children
  // (inserted from the /cart/add.js sections response in renderContents) are
  // post-add, but they don't expose the full cart shape we need for the event
  // payload. So we keep an explicit /cart.json fetch on open. Migrating to the
  // factory + filter would require re-rendering the notification element
  // itself in sections, which is out of scope for this PR.
  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      const cart = await response.json();
      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // cart:view is informational; swallow fetch errors
    }
  }

  close() {
    if (!this.notification.open) return;
    this.notification.querySelectorAll('cart-disclosure-modal[open]').forEach((modal) => modal.hide(false));
    this.notification.close();
    this.notification.classList.remove('active');
    document.body.classList.remove('cart-notification-open');
    this.notification.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement?.isConnected ? this.activeElement : document.querySelector('#cart-icon-bubble'));
    this.activeElement = null;
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    if (evt.target !== this.notification) return;
    const rect = this.notification.getBoundingClientRect();
    if (evt.clientX < rect.left || evt.clientX > rect.right || evt.clientY < rect.top || evt.clientY > rect.bottom) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
